module.exports = __webpack_public_path__ + "static/img/16.29119ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/16.jpg
// module id = Fzpv
// module chunks = 1